import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';

/**
 * RefreshIndicator — Non-blocking spinner overlay shown during auto-refresh.
 * Displays a small spinner in the top-right corner of the dashboard without
 * replacing the currently displayed content.
 */
const RefreshIndicator = ({ isRefreshing }) => {
  if (!isRefreshing) return null;

  return (
    <div
      className="d-flex align-items-center gap-2"
      style={{
        position: 'fixed',
        top: 12,
        right: 20,
        zIndex: 1050,
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        borderRadius: '6px',
        padding: '6px 12px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        fontSize: '0.8rem',
        color: '#555',
      }}
      role="status"
      aria-label="Refreshing dashboard data"
    >
      <Spinner animation="border" size="sm" variant="primary" aria-hidden="true" />
      <span>Refreshing…</span>
    </div>
  );
};

RefreshIndicator.propTypes = {
  isRefreshing: PropTypes.bool.isRequired,
};

export default RefreshIndicator;
